import {BootstrapFormControl} from './BootstrapFormControl';
import {wrap, type GetProps} from 'src/components/util/Controls/wrap';
import {type Form} from 'react-bootstrap';

export const FormControl = wrap(BootstrapFormControl) as typeof Form.Control;
export type FormControlProps = GetProps<typeof FormControl>;

export type FormControlElement = HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;
